// export const games = {
//     "yx": "ゲーム",
//     "yxms": "暗号化されたゲームでは、競技の結果を決定するすべての決定は、ハッシュの形で事前に生成され、誰の意志にもよってゲームの結果は変更されません。これにより、絶対的な公平さと正義が確保されます。",
//     "mnsm": "シミュレートされたトライアル",
//     "ljqw": "今すぐプレイ",
//     loading: '"読み込み中、お待ちください'
// }
export const games = {
    yx: 'ゲーム',
    yxms: '暗号化されたゲームのすべての決定結果は、参加前にハッシュ形式で生成されます。誰の意志でもゲームの結果を変えることはできず、絶対的な公平さと公正さを保証します！',
    mnsm: '試用プレイ',
    ljqw: '今すぐプレイ',
    loading: '読み込み中、お待ちください',
    dyh: '選べる多様なオプション契約、利益100倍、超高短期投資収益率',
        qyhy:'オプション契約',
        qsyhys:'オプション',
    kd:'注文を開く',
    qt:'クトゥ',
    ljjy: "今すぐ取引してください",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/ja_JP.js